import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { RfpMessageListItem, RfpMessageListItemSkeleton, } from '@/components/modules/pages/rfp/client/List/RfpMessageListItem';
import { SelectableList } from '@/components/ui/List/SelectableList';
import { useArrayWithIndex } from '@/hooks/array/useArrayWithIndex';
/**
 * クライアント：ファイル共有のコンテンツ部分
 * @param props
 * @constructor
 */
export const RfpFileList = (props) => {
    const { children, className = '', disabled, isCallEnd, items, loading, onClick, selectedId, } = props;
    const dummies = useArrayWithIndex(4);
    return (_jsxs("div", Object.assign({ className: clsx('flex flex-row items-start gap-x-16', className) }, { children: [_jsx("div", Object.assign({ className: clsx('hidden md:block lg:hidden xl:block', 'w-[200px]', 'flex-shrink-0') }, { children: _jsx(SelectableList, Object.assign({ className: 'flex-shrink-0' }, { children: (() => {
                        // ローディング中
                        if (loading && !(items === null || items === void 0 ? void 0 : items.length)) {
                            return dummies.map(({ index }) => (_jsx(RfpMessageListItemSkeleton, {}, `RfpMessageListItemSkeleton_${index}`)));
                        }
                        // 0件表示（基本的に表示されない想定）
                        if (!(items === null || items === void 0 ? void 0 : items.length)) {
                            return null;
                        }
                        // 閲覧申請一覧
                        return items.map((item) => (_jsx(RfpMessageListItem, { companyName: item.companyName, disabled: disabled, hasUnAnswer: !isCallEnd && item.hasUnAnswer, id: item.id, isSelected: item.id === selectedId, onClick: onClick, unReadCount: item.unReadCount }, item.id)));
                    })() })) })), _jsx("div", Object.assign({ className: clsx('flex-grow') }, { children: _jsx(SelectableList, { children: children }) }))] })));
};
